import React from "react";
import { HomeDashboard } from "../components/HomeDashboard/HomeDashboard";

export const IndexPage = () => {

  return (
    <HomeDashboard />
  );
};
